// extracted by mini-css-extract-plugin
module.exports = {"navigationActions":"UsersManagementPage_navigationActions__1sQtG","action":"UsersManagementPage_action__1SUF6","actionRight":"UsersManagementPage_actionRight__2ygJj"};